import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { myAxios } from "src/components/common/functions";

export async function trainingsLoader() {
    const res = await myAxios({ fileName: "trainings/getTrainings.php" });
    if (!res) throw redirect("..");
    return res.data;
}

export async function trainingDataLoader() {
    const preRes = await myAxios({ fileName: "trainings/getTrainingData.php" });
    if (!preRes) throw redirect("..");
    let rawData = {};
    const url = preRes.data;
    if (url) {
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error("Failed to fetch file");
            const text = await response.text();
            rawData = JSON.parse(text) || {};
        } catch (err) {
            console.error("Download trainings file failed", err);
            rawData = {};
        }
    }
    return rawData;
}

export async function trainingDetailLoader({ params }: LoaderFunctionArgs) {
    const { id } = params;
    if (!id) {
        throw redirect("..");
    }
    const formData = new FormData();
    formData.append("fileId", id);
    const preRes = await myAxios({
        fileName: "trainings/getTraining.php", 
        formData, 
        redirectPath: ".."
    });
    if (!preRes) throw redirect("..");
    const url = preRes.data;
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error("Failed to fetch file");
        }
        const text = await response.text();
        const jsonData = JSON.parse(text);
        return {
            questions: jsonData.questions ?? [],
            mode: jsonData.mode,
            name: jsonData.name,
            passScore: jsonData.passScore
        };
    } catch (err) {
        throw new Response("Failed to load trainings file", { status: 500 });
    }
}